import { makeStyles } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { useTranslation } from 'react-i18next';
import { fromNewDateFormatToDDMMYYYYSlash } from '../../Helpers/dateHelper';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

export default function ProductDataTable(props) {
    const classes = useStyles();

    const { t } = useTranslation();

    console.log(props.orderLines)
    console.log(props.products)
    const rows = props.orderLines.map(p => {

        let value = props.products.find(x => x.ID === p.productID).value
        let uom = props.uoms.find(x => x.ID === p.unitOfMeasurementID)
        return (
            createData(p.fromDate, p.toDate, value, p.quantity, uom.Code, p.unitPrice100Kg, p.id))
    }
    )

    function createData(fromDate, toDate, value, quantity, uom, unitPrice, id) {
        return { fromDate, toDate, value, quantity, uom, unitPrice, id };
    }

    return (
        <Table className={classes.table} aria-label="customized table">
            <TableHead>
                <TableRow>
                    <TableCell className={classes.headCell} style={{ width: "15%" }}>From</TableCell>
                    <TableCell className={classes.headCell} style={{ width: "15%" }}>To</TableCell>
                    <TableCell className={classes.headCell} style={{ width: "30%" }}>Product</TableCell>
                    <TableCell className={classes.headCell} style={{ width: "5%" }}>Quantity</TableCell>
                    <TableCell className={classes.headCell} style={{ width: "5%" }}>UOM</TableCell>
                    <TableCell className={classes.headCell} style={{ width: "8%" }}>UnitPrice</TableCell>
                    <TableCell className={classes.headCell} style={{ width: "5%" }}></TableCell>
                    <TableCell className={classes.headCell} style={{ width: "5%" }}></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((row) => (
                    <TableRow key={row.id} className={classes.row}>
                        <TableCell className={classes.infoCell} style={{ width: "15%" }}>{fromNewDateFormatToDDMMYYYYSlash(new Date(row.fromDate))}</TableCell>
                        <TableCell className={classes.infoCell} style={{ width: "15%" }}>{fromNewDateFormatToDDMMYYYYSlash(new Date(row.toDate))}</TableCell>
                        <TableCell className={classes.infoCell} style={{ width: "35%" }}>{row.value}</TableCell>
                        <TableCell className={classes.infoCell} style={{ width: "7%" }}>{row.quantity}</TableCell>
                        <TableCell className={classes.infoCell} style={{ width: "5%" }}>{row.uom}</TableCell>
                        <TableCell className={classes.infoCell} style={{ width: "5%" }}>{row.unitPrice}</TableCell>
                        <TableCell className={classes.infoCell} style={{ width: "5%" }}>
                            <EditIcon className={classes.editIcon} onClick={() => props.editWeighing(row.id)}></EditIcon>
                        </TableCell>
                        <TableCell className={classes.infoCell} style={{ width: "5%" }}>
                            <DeleteIcon className={classes.deleteIcon} onClick={() => props.removeWeighing(row.id)}></DeleteIcon>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    )

}

const useStyles = makeStyles(() => ({
    headCell: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        padding: "0px",
        border: "none",
        height: "10px",
        lineHeight: "0px"
    },

    infoCell: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        padding: "5px",
        paddingLeft: "0px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        backgroundColor: "white",
        width: "30%"
    },

    table: {
        borderSpacing: "0 5px !important",
        borderCollapse: "separate !important",
        width: "100%"

    },
    editIcon: {
        cursor: "pointer",
        color: "#1976d2",
        paddingTop: "5px"
    },
    deleteIcon: {
        cursor: "pointer",
        color: "#1976d2",
        paddingTop: "5px"
    }

}));